import { render, staticRenderFns } from "./TopSale.vue?vue&type=template&id=56fb043a&scoped=true"
import script from "./TopSale.vue?vue&type=script&lang=js"
export * from "./TopSale.vue?vue&type=script&lang=js"
import style0 from "./TopSale.vue?vue&type=style&index=0&id=56fb043a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb043a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fb043a')) {
      api.createRecord('56fb043a', component.options)
    } else {
      api.reload('56fb043a', component.options)
    }
    module.hot.accept("./TopSale.vue?vue&type=template&id=56fb043a&scoped=true", function () {
      api.rerender('56fb043a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/components/TopSale.vue"
export default component.exports